import { Controller } from "@hotwired/stimulus"
import { Director, Publish } from "@millicast/sdk"

export default class extends Controller {
  static values = { streamName: String, token: String }
  static targets = ["button", "camera"]

  connect() {
    this.publisher = new Publish(
      undefined, // The first argument is deprecated.
      () => Director.getPublisher({ token: this.tokenValue, streamName: this.streamNameValue })
    )
  }

  // Leaving the page through Turbo keeps its JavaScript running, so a broadcast still going would
  // keep publishing, and the camera and microphone stay on, until the tab is closed.
  disconnect() {
    if (this.publisher.isActive()) {
      this.publisher.stop()
    }

    this.#releaseMediaStream()
  }

  toggle(event) {
    const { target } = event

    if (this.publisher.isActive()) {
      this.#stop(target)
    } else {
      this.#start(target)
    }
  }

  #stop(target) {
    this.publisher.stop()
    this.#releaseMediaStream()

    this.#setButtonStart(target)
  }

  #releaseMediaStream() {
    this.mediaStream?.getTracks().forEach(track => {
      track.stop()
    })
    this.mediaStream = null
  }

  #start(target) {
    this.#setButtonStarting(target)

    navigator.mediaDevices
      .getUserMedia({ audio: true, video: { facingMode: this.cameraTarget.value, aspectRatio: 16 / 9 } })
      .then(mediaStream => {
        this.mediaStream = mediaStream
        this.publisher
          .connect({ mediaStream })
          .then(() => {
            this.#setButtonStop(target)
          })
          .catch(() => {
            // The camera was granted before the broadcast failed; it is not kept on for nothing.
            this.#releaseMediaStream()
            this.#setButtonStart(target)
          })
      })
      .catch(() => {
        this.#setButtonStart(target)
      })
  }

  #setButtonStart(target) {
    target.textContent = "Start"
    target.disabled = false
  }

  #setButtonStop(target) {
    target.textContent = "Stop"
    target.disabled = false
  }

  #setButtonStarting(target) {
    target.textContent = "Starting..."
    target.disabled = true
  }
}
